import Control from '@/Controls/Control';
import DateAndOrTimePickerViewModelBase from '@/ViewModels/Controls/DateAndOrTimePickerViewModelBase';

import Utilities from "@/Utility/Utilities";
export default class DateAndOrTimePicker extends Control {

    protected jQueryControl: JQuery;
    public constructor(protected viewModel: DateAndOrTimePickerViewModelBase, protected element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    protected onWidgetCreatedCallback(widget: null): void {

        this.applyBindings(this.jQueryControl, {

            autoLocator: this.viewModel.locator,

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,

            visible: this.viewModel.isVisible,

            styles: this.definePureComputed({
                read: () => {
                    let styles = [];

                    return styles;
                }
            }),

            states: this.definePureComputed({
                read: () => {
                    let states = [];

                    if (this.viewModel.isRequired() === true) {
                        states.push('required');
                    }

                    if (this.viewModel.isValid() === true) {
                        states.push('valid');
                    } else {
                        states.push('invalid');
                    }

                    if (this.viewModel.isEnabled() === true) {
                        states.push('enabled');
                    } else {
                        states.push('disabled');
                    }

                    return states;
                }
            })
        });

        const $input = this.jQueryControl.find('input');
        this.applyBindings($input, {

            focus: this.viewModel.isFocusable,

            value: this.viewModel.rawValue,

            tooltip: this.viewModel.tooltip,

            attr: {
                title: '',
                readonly: this.defineComputed(() => {
                    return !this.viewModel.isEnabled();
                })
            }
        });
        
        const $wrapper = this.jQueryControl.find('.native-wrapper');
        this.applyBindings($wrapper, {
            invalid: this.viewModel.invalidationText,
        });
        
        this.addEventHandler('keyup', $input, Utilities.debounce((event: JQuery.KeyUpEvent) => this.changeCallback($input[0]), 1000));
        this.addEventHandler('change', $input, (event: JQuery.ChangeEvent) => this.changeCallback($input[0]));
        this.viewModel.onResetted(() => $input.val($input[0].defaultValue));
    }

    protected createControl(element: JQuery, inputType: string, cssClass: string): JQuery {
        if (!element) {
            element = $('<div></div>');
        }

        element.find('.c-wrapper').contents().unwrap();
        let input = element.find('input');

        if (input.length > 0) {
            input.attr('type', inputType);

            if (cssClass)
                input.attr('class', cssClass);

            this.viewModel.validity(input[0]?.validity?.valid);
        } else {
            const wrapper = $('<div>', {
                class: 'native-wrapper',
            });
            
            input = $('<input>', {
                type: inputType,
                class: cssClass
            });

            wrapper.append(input);
            
            this.viewModel.validity(input[0]?.validity?.valid);
            element.append(wrapper);
        }

        return element;
    }

    private changeCallback(inputElement: HTMLInputElement) {
        if (this.isDisposed)
            return;
        
        this.viewModel.validity(inputElement?.validity?.valid);
    }

    public addLabelReference(label: JQuery): JQuery {
        let id = this.identifier + '-input';
        this.getControl().find('input').attr('id', id);
        label.attr('for', id);
        return label;
    }
}